export function relativeTime(iso: string): string {
  const d = new Date(iso).getTime();
  const s = Math.round((Date.now() - d) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 86400 * 7) return `${Math.floor(s / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
}
export function bytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 ** 2).toFixed(1)} MB`;
}
export function groupByDate<T extends { updatedAt: string }>(items: T[]): [string, T[]][] {
  const now = new Date();
  const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const groups = new Map<string, T[]>();
  for (const it of items) {
    const t = new Date(it.updatedAt).getTime();
    const label = t >= startOfDay ? 'Today' : t >= startOfDay - 86400e3 ? 'Yesterday' : t >= startOfDay - 7 * 86400e3 ? 'Previous 7 days' : t >= startOfDay - 30 * 86400e3 ? 'Previous 30 days' : 'Older';
    (groups.get(label) ?? groups.set(label, []).get(label)!).push(it);
  }
  return [...groups];
}
export const cx = (...c: (string | false | null | undefined)[]) => c.filter(Boolean).join(' ');
